import React from 'react';
import styled from 'styled-components';
import breakpoints from '@/constants/breakpoints';

export default function WeLoveCard() {
  return (
    <Container>
      <Copy>
        <Title>Designer looks we love</Title>
        <Subtitle>(we'll let you take the credit)</Subtitle>
      </Copy>
    </Container>
  );
}

const Container = styled.div`
  padding: 0 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2D424F;
  height: 97.715%;

  @media (min-width: ${breakpoints['small-tablet']}px) {
    height: 97.85%;
  }

  @media (min-width: ${breakpoints['tablet']}px) {
    height: 98.4%;
  }

  @media (min-width: ${breakpoints['desktop']}px) {
    height: 99%;
  }
`;

const Copy = styled.div`


  @media (min-width: ${breakpoints['tablet']}px) {
    max-width: 107px;
  }

  @media (min-width: ${breakpoints['desktop']}px) {
    max-width: 160px;
  }

  @media (min-width: ${breakpoints['large-desktop']}px) {
    max-width: 205px;
  }
`;

const Title = styled.p`
  font-family: ${props => props.theme.fonts.secondary.family};
  color: #D2E0EA;
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: -0.48px;
  text-align: center;

  @media (min-width: ${breakpoints['tablet']}px) {
    font-size: 26px;
    margin: 0 0 19.6px;
    line-height: 1.23;
    letter-spacing: normal;

  }

  @media (min-width: ${breakpoints['desktop']}px) {
    font-size: 32px;
    margin: 0 0 23.5px;
    line-height: 1.19;
    letter-spacing: normal;
  }

  @media (min-width: ${breakpoints['large-desktop']}px) {
    font-size: 44px;
    margin: 0 0 27px;
    line-height: 1.27;
    letter-spacing: -0.88px;
  }
`;

const Subtitle = styled.p`
  margin: 0;
  font-family: ${props => props.theme.fonts.secondary.family};
  color: #D2E0EA;
  text-align: center;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.25;
  letter-spacing: -0.32px;
  font-style: italic;

  @media (min-width: ${breakpoints['tablet']}px) {
    line-height: 1.38;
    letter-spacing: normal;
  }

  @media (min-width: ${breakpoints['desktop']}px) {
    font-size: 20px;
    line-height: 1.3;
  }

  @media (min-width: ${breakpoints['desktop']}px) {
    font-size: 24px;
    line-height: 1.33;
  }
`;
